'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errcode = require('err-code');

var pTimeout = require('p-timeout');

var libp2pRecord = require('libp2p-record');

var c = require('../constants');

var Query = require('../query');

var utils = require('../utils');

var Record = libp2pRecord.Record;

module.exports = function (dht) {
  var putLocal = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, rec) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dht.datastore.put(utils.bufferToKey(key), rec));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function putLocal(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * Attempt to retrieve the value for the given key from
   * the local datastore.
   *
   * @param {Buffer} key
   * @returns {Promise<Record>}
   *
   * @private
   */


  var getLocal = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
      var raw, rec;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dht._log('getLocal %b', key);

              _context2.next = 3;
              return dht.datastore.get(utils.bufferToKey(key));

            case 3:
              raw = _context2.sent;

              dht._log('found %b in local datastore', key);

              rec = Record.deserialize(raw);
              _context2.next = 8;
              return dht._verifyRecordLocally(rec);

            case 8:
              return _context2.abrupt("return", rec);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getLocal(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Send the best record found to any peers that have an out of date record.
   *
   * @param {Buffer} key
   * @param {Array<Object>} vals - values retrieved from the DHT
   * @param {Object} best - the best record that was found
   * @returns {Promise}
   *
   * @private
   */


  var sendCorrectionRecord = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key, vals, best) {
      var fixupRec;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return utils.createPutRecord(key, best);

            case 2:
              fixupRec = _context4.sent;
              return _context4.abrupt("return", Promise.all(vals.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(v) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!v.val.equals(best)) {
                            _context3.next = 2;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 2:
                          if (!dht._isSelf(v.from)) {
                            _context3.next = 12;
                            break;
                          }

                          _context3.prev = 3;
                          _context3.next = 6;
                          return dht._putLocal(key, fixupRec);

                        case 6:
                          _context3.next = 11;
                          break;

                        case 8:
                          _context3.prev = 8;
                          _context3.t0 = _context3["catch"](3);

                          dht._log.error('Failed error correcting self', _context3.t0);

                        case 11:
                          return _context3.abrupt("return");

                        case 12:
                          _context3.prev = 12;
                          _context3.next = 15;
                          return dht._putValueToPeer(key, fixupRec, v.from);

                        case 15:
                          _context3.next = 20;
                          break;

                        case 17:
                          _context3.prev = 17;
                          _context3.t1 = _context3["catch"](12);

                          dht._log.error('Failed error correcting entry', _context3.t1);

                        case 20:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[3, 8], [12, 17]]);
                }));

                return function (_x7) {
                  return _ref4.apply(this, arguments);
                };
              }())));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function sendCorrectionRecord(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    /**
     * Store the given key/value pair locally, in the datastore.
     * @param {Buffer} key
     * @param {Buffer} rec - encoded record
     * @returns {Promise<void>}
     * @private
     */
    _putLocal: function _putLocal(key, rec) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", putLocal(key, rec));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * Store the given key/value  pair in the DHT.
     *
     * @param {Buffer} key
     * @param {Buffer} value
     * @param {Object} [options] - put options
     * @param {number} [options.minPeers] - minimum number of peers required to successfully put (default: closestPeers.length)
     * @returns {Promise<void>}
     */
    put: function put(key, value) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var options, record, counterAll, counterSuccess, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, peer, minPeers, error;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};

                dht._log('PutValue %b', key); // create record in the dht format


                _context6.next = 4;
                return utils.createPutRecord(key, value);

              case 4:
                record = _context6.sent;
                _context6.next = 7;
                return putLocal(key, record);

              case 7:
                // put record to the closest peers
                counterAll = 0;
                counterSuccess = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context6.prev = 11;
                _iterator = _asyncIterator(dht.getClosestPeers(key, {
                  shallow: true
                }));

              case 13:
                _context6.next = 15;
                return _iterator.next();

              case 15:
                _step = _context6.sent;
                _iteratorNormalCompletion = _step.done;
                _context6.next = 19;
                return _step.value;

              case 19:
                _value = _context6.sent;

                if (_iteratorNormalCompletion) {
                  _context6.next = 35;
                  break;
                }

                peer = _value;
                _context6.prev = 22;
                counterAll += 1;
                _context6.next = 26;
                return dht._putValueToPeer(key, record, peer);

              case 26:
                counterSuccess += 1;
                _context6.next = 32;
                break;

              case 29:
                _context6.prev = 29;
                _context6.t0 = _context6["catch"](22);

                dht._log.error('Failed to put to peer (%b): %s', peer.id, _context6.t0);

              case 32:
                _iteratorNormalCompletion = true;
                _context6.next = 13;
                break;

              case 35:
                _context6.next = 41;
                break;

              case 37:
                _context6.prev = 37;
                _context6.t1 = _context6["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context6.t1;

              case 41:
                _context6.prev = 41;
                _context6.prev = 42;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context6.next = 46;
                  break;
                }

                _context6.next = 46;
                return _iterator.return();

              case 46:
                _context6.prev = 46;

                if (!_didIteratorError) {
                  _context6.next = 49;
                  break;
                }

                throw _iteratorError;

              case 49:
                return _context6.finish(46);

              case 50:
                return _context6.finish(41);

              case 51:
                // verify if we were able to put to enough peers
                minPeers = options.minPeers || counterAll; // Ensure we have a default `minPeers`

                if (!(minPeers > counterSuccess)) {
                  _context6.next = 56;
                  break;
                }

                error = errcode(new Error("Failed to put value to enough peers: ".concat(counterSuccess, "/").concat(minPeers)), 'ERR_NOT_ENOUGH_PUT_PEERS');

                dht._log.error(error);

                throw error;

              case 56:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[11, 37, 41, 51], [22, 29], [42,, 46, 50]]);
      }))();
    },

    /**
     * Get the value to the given key.
     * Times out after 1 minute by default.
     *
     * @param {Buffer} key
     * @param {Object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     * @returns {Promise<Buffer>}
     */
    get: function get(key) {
      var _arguments2 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var options, vals, recs, i, best;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {};
                options.timeout = options.timeout || c.minute;

                dht._log('_get %b', key);

                _context7.next = 5;
                return dht.getMany(key, c.GET_MANY_RECORD_COUNT, options);

              case 5:
                vals = _context7.sent;
                recs = vals.map(function (v) {
                  return v.val;
                });
                i = 0;
                _context7.prev = 8;
                i = libp2pRecord.selection.bestRecord(dht.selectors, key, recs);
                _context7.next = 16;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](8);

                if (!(_context7.t0.code !== 'ERR_NO_SELECTOR_FUNCTION_FOR_RECORD_KEY')) {
                  _context7.next = 16;
                  break;
                }

                throw _context7.t0;

              case 16:
                best = recs[i];

                dht._log('GetValue %b %s', key, best);

                if (best) {
                  _context7.next = 20;
                  break;
                }

                throw errcode(new Error('best value was not found'), 'ERR_NOT_FOUND');

              case 20:
                _context7.next = 22;
                return sendCorrectionRecord(key, vals, best);

              case 22:
                return _context7.abrupt("return", best);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[8, 12]]);
      }))();
    },

    /**
     * Get the `n` values to the given key without sorting.
     *
     * @param {Buffer} key
     * @param {number} nvals
     * @param {Object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     * @returns {Promise<Array<{from: PeerId, val: Buffer}>>}
     */
    getMany: function getMany(key, nvals) {
      var _arguments3 = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var options, vals, localRec, paths, id, rtp, errMsg, query, error;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                options = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : {};
                options.timeout = options.timeout || c.minute;

                dht._log('getMany %b (%s)', key, nvals);

                vals = [];
                _context9.prev = 4;
                _context9.next = 7;
                return getLocal(key);

              case 7:
                localRec = _context9.sent;
                _context9.next = 14;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](4);

                if (!(nvals === 0)) {
                  _context9.next = 14;
                  break;
                }

                throw _context9.t0;

              case 14:
                if (localRec) {
                  vals.push({
                    val: localRec.value,
                    from: dht.peerInfo.id
                  });
                }

                if (!(vals.length >= nvals)) {
                  _context9.next = 17;
                  break;
                }

                return _context9.abrupt("return", vals);

              case 17:
                paths = [];
                _context9.next = 20;
                return utils.convertBuffer(key);

              case 20:
                id = _context9.sent;
                rtp = dht.routingTable.closestPeers(id, _this.kBucketSize);

                dht._log('peers in rt: %d', rtp.length);

                if (!(rtp.length === 0)) {
                  _context9.next = 29;
                  break;
                }

                errMsg = 'Failed to lookup key! No peers from routing table!';

                dht._log.error(errMsg);

                if (!(vals.length === 0)) {
                  _context9.next = 28;
                  break;
                }

                throw errcode(new Error(errMsg), 'ERR_NO_PEERS_IN_ROUTING_TABLE');

              case 28:
                return _context9.abrupt("return", vals);

              case 29:
                // we have peers, lets do the actual query to them
                query = new Query(dht, key, function (pathIndex, numPaths) {
                  // This function body runs once per disjoint path
                  var pathSize = utils.pathSize(nvals - vals.length, numPaths);
                  var pathVals = [];
                  paths.push(pathVals); // Here we return the query function to use on this particular disjoint path

                  return /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(peer) {
                      var rec, peers, lookupErr, results, res;
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              _context8.prev = 0;
                              _context8.next = 3;
                              return dht._getValueOrPeers(peer, key);

                            case 3:
                              results = _context8.sent;
                              rec = results.record;
                              peers = results.peers;
                              _context8.next = 13;
                              break;

                            case 8:
                              _context8.prev = 8;
                              _context8.t0 = _context8["catch"](0);

                              if (!(_context8.t0.code !== 'ERR_INVALID_RECORD')) {
                                _context8.next = 12;
                                break;
                              }

                              throw _context8.t0;

                            case 12:
                              lookupErr = _context8.t0;

                            case 13:
                              res = {
                                closerPeers: peers
                              };

                              if (rec && rec.value || lookupErr) {
                                pathVals.push({
                                  val: rec && rec.value,
                                  from: peer
                                });
                              } // enough is enough


                              if (pathVals.length >= pathSize) {
                                res.pathComplete = true;
                              }

                              return _context8.abrupt("return", res);

                            case 17:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8, null, [[0, 8]]);
                    }));

                    return function (_x8) {
                      return _ref5.apply(this, arguments);
                    };
                  }();
                });
                _context9.prev = 30;
                _context9.next = 33;
                return pTimeout(query.run(rtp), options.timeout);

              case 33:
                _context9.next = 38;
                break;

              case 35:
                _context9.prev = 35;
                _context9.t1 = _context9["catch"](30);
                error = _context9.t1;

              case 38:
                query.stop(); // combine vals from each path

                vals = [].concat.apply(vals, paths).slice(0, nvals);

                if (!(error && vals.length === 0)) {
                  _context9.next = 42;
                  break;
                }

                throw error;

              case 42:
                return _context9.abrupt("return", vals);

              case 43:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[4, 10], [30, 35]]);
      }))();
    }
  };
};